import * as React from "react";
const SvgChevronUpIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 9, viewBox: "0 0 12 9", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.59 8.25L6 3.67L1.41 8.25L0 6.84L6 0.84L12 6.84L10.59 8.25Z", fill: "black" }));
export default SvgChevronUpIcon;
